import { ColourOption, colourLabel } from '../../components/colour-select/colour-option';

/**
 * Brand palette for CMS blocks (#226 Background, #227 Text colour) and, from
 * #264, for each Panel grid panel — the same lists and names everywhere.
 *
 * The deck (brand_guidelines/picaluna-pitch_0023) NAMES these five; it prints
 * no hex codes, so the values are sampled from the swatches themselves.
 *
 * `value` must match picaluna-v3 (src/lib/blockColours.ts) and the server's
 * whitelist (api/classes/external/page-colours.ts) EXACTLY: an unknown block
 * colour aborts the whole site build, not just the page carrying it. The hex
 * is for the swatch only — the site renders from its own tokens, so treat
 * picaluna-v3/src/styles/global.css as truth.
 */

/* "Blue tint" removed 2026-10-05 (Ivan): it was ours, not the deck's — a
   lighter blue Robin asked for that is nowhere in brand canon. The VALUE
   stays live in picaluna-v3's zod enum and global.css, so any section still
   carrying it renders as before; it is only off the menu. Removing it from
   the enum too would abort the build on a stored section. */
export const BACKGROUND_OPTIONS: ColourOption[] = [
  { label: 'Off white', value: 'off-white', hex: '#FFF9F1' },
  { label: 'Picaluna Blue', value: 'blue', hex: '#66B5D0' },
  { label: 'Forest Green', value: 'forest', hex: '#0B280A' },
  { label: 'Burnt Orange', value: 'orange', hex: '#B04C22' },
  { label: 'Brand Black', value: 'brand-black', hex: '#0A0A0A' },
  /* White (Robin, 2026-10-29): in every palette select. */
  { label: 'White', value: 'white', hex: '#FFFFFF' },
];

/** Same palette; Blue tint is omitted — a tint that reads as a background is
 *  too pale for body copy on off-white. */
export const TEXT_COLOUR_OPTIONS: ColourOption[] = [
  { label: 'Brand Black', value: 'brand-black', hex: '#0A0A0A' },
  { label: 'Off white', value: 'off-white', hex: '#FFF9F1' },
  { label: 'Forest Green', value: 'forest', hex: '#0B280A' },
  { label: 'Burnt Orange', value: 'orange', hex: '#B04C22' },
  { label: 'Picaluna Blue', value: 'blue', hex: '#66B5D0' },
  { label: 'White', value: 'white', hex: '#FFFFFF' },
];

/**
 * What a panel's own select says while it is blank (#264): the block's Panel
 * colour it inherits when one is set, else `none`, which is what blank means
 * on its own.
 */
export function inheritedPlaceholder(
  options: ColourOption[],
  blockValue: string | null | undefined,
  none: string
): string {
  return blockValue ? `Block default (${colourLabel(options, blockValue)})` : none;
}
